define [], () ->
  ($resource, RENTAPPLICATION_API_URL) ->
    $resource(
      "#{RENTAPPLICATION_API_URL}/api/v2/user/:id/",
      {},
      {
        get:
          cache: true
        getMe:
          url: "#{RENTAPPLICATION_API_URL}/api/v2/user/"
          cache: true
          transformResponse: (response) ->
            if !response
              return
            response = angular.fromJson(response)
            if response.results and response.results.length
              me = response.results[0]
              me
        check_available:
          url: "#{RENTAPPLICATION_API_URL}/api/v1/user/check_available/:username/"
          cache: true
          transformResponse: (response) ->
            response = angular.fromJson(response)
            response
      }
    )



// WEBPACK FOOTER //
// ./resources/User.coffee